import { render, staticRenderFns } from "./QaModal.vue?vue&type=template&id=6e946bea&"
import script from "./QaModal.vue?vue&type=script&lang=js&"
export * from "./QaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e946bea')) {
      api.createRecord('6e946bea', component.options)
    } else {
      api.reload('6e946bea', component.options)
    }
    module.hot.accept("./QaModal.vue?vue&type=template&id=6e946bea&", function () {
      api.rerender('6e946bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/qa/modules/QaModal.vue"
export default component.exports